var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownArrowFilter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 7,
    viewBox: "0 0 13 7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "down-arrow",
    transform: "translate(0 -117.336)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13514",
    "data-name": "Group 13514",
    transform: "translate(0 117.336)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38050",
    "data-name": "Path 38050",
    d: "M12.841,117.494a.543.543,0,0,0-.766,0L6.5,123.036.925,117.494a.543.543,0,0,0-.766,0,.536.536,0,0,0,0,.761l5.958,5.923a.544.544,0,0,0,.766,0l5.958-5.923A.536.536,0,0,0,12.841,117.494Z",
    transform: "translate(0 -117.336)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrowFilter);
export default __webpack_public_path__ + "static/media/down-arrow-filter.3fde6bf0.svg";
export { ForwardRef as ReactComponent };